export const getRangeByScore = (ranges, score) => ranges.find(({ min, max }) => score >= min && score <= max);

export default {
  getRangeByScore,
};
